import React from "react";
import styled from "styled-components";
import { Select, Spin } from "antd";
import { useSelector } from "react-redux";

const { Option } = Select;

const StyledWrapper = styled(Select)`
  width: 100%;

  &.ant-select:not(.ant-select-customize-input) .ant-select-selector {
    width: 100%;
    border-radius: 10px;
  }
`;

const DropdownWrapper = (props) => {
  const { lang } = useSelector((state) => state.languageSelectorReducer);
  const { loading, bankMenu } = props;

  return (
    <StyledWrapper {...props} disabled={loading}>
      {loading ? (
        <Spin style={{ display: "flex", justifyContent: "center", width: "100%" }} />
      ) : (
        bankMenu.map((item) => (
          <Option
            style={{background: item?.hasOwnProperty('isAvailable') && !item.isAvailable && "#f5f5f5"}}
            disabled={item?.hasOwnProperty('isAvailable') && !item.isAvailable ? true : false}
            key={item?.hasOwnProperty('isAvailable') ? item.bankNameEng : item.id}
            value={lang == "th" ? item.bankNameThai : item.bankNameEng}
          >
            {lang == "th" ? item.bankNameThai : item.bankNameEng}
          </Option>
        ))
      )}
    </StyledWrapper>
  );
};

export default DropdownWrapper;
